import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { Typography } from '@mui/material';

export default function SideDrawer(props) {
    const { title, body, footer, openPanel, closePanel } = props




    const closeHandel = (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        closePanel(false)
    }


    return (
        <div>
            <React.Fragment>
                <Drawer
                    anchor={'right'}
                    open={openPanel}
                    onClose={closeHandel}
                >
                    <Box
                        sx={{ width: 350, zIndex: 99999 }}
                        role="presentation"
                        onKeyDown={closeHandel}
                    >
                        <Box className='p-5'></Box>
                        <Box className='d-flex flex-column justify-content-between'>
                            <Box className='p-2'>
                                <Typography variant='h4' className='fw-bold'>{title}</Typography>
                            </Box>
                            <Box className='p-2 overflow-auto'>
                                {body}
                            </Box>
                            <Box className='p-2'>
                                {footer}
                            </Box>
                        </Box>
                    </Box>
                </Drawer>
            </React.Fragment>

        </div>
    );
}